<template>
  <div class="notSelectedPuri">
    <template v-if="this.contents && uris.length > 0">
      <div class="notSelectedPuri__wrapper" :class="{'--underThree': uris.length < 3}">
        <div class="cell sampleImage" v-for="(value, index) in uris" :key="index">
          <img class="thumbnail" v-lazy="value">
          <div v-if="notSelectedContents[index].hasgraff && !notSelectedContents[index].surpriseShot2" class="graffity" />
          <div v-if="notSelectedContents[index].surpriseShot || notSelectedContents[index].surpriseShot2" class="surprise" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Screen from '../mixins/screen'
import Protobuf from '../mixins/protobuf'

const { toJpegURI } = require('../assets/js/util')

export default {
  name: "PuriContentsBottom",
  mixins: [Protobuf, Screen],
  props: {
    contents: {
      type: Array,
      require: true,
    },
    notSelectedContents: {
      type: Array,
      require: true,
    }
  },
  mounted(){
  },
  computed: {
    uris() {
      return this.notSelectedContents.map(c => toJpegURI(c.bytes))
    },
  },
}
</script>

<style lang="scss" scoped>
.notSelectedPuri {
  position: relative;
  &__wrapper {
    width: fit-content;
    height: fit-content;
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    .cell {
      position: relative;
      width: 81px;
      height: 100px;
      margin-right: 4px;
      margin-bottom: 4px;
      &:nth-of-type(4n){
        margin-right: 0;
      }
      .graffity {
        position: absolute;
        width: 35px;
        height: 35px;
        bottom: 1px;
        right: 1px;
        background-image: url(../assets/Png/Album/Album_Puri_Graffiti.png);
        background-size: contain;
        z-index: 10;
      }
      .surprise {
        position: absolute;
        width: 35px;
        height: 35px;
        top: 1px;
        right: 1px;
        background-image: url(../assets/Png/Album/Album_PuriMotto.png);
        background-size: contain;
        z-index: 10;
      }
    }
    .sampleImage {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        opacity: 1;
        filter: saturate(180%);
        background-image: url(../assets/Png/Common/puriSample.png);
        background-repeat: no-repeat;
        background-size: cover;
      }
    }
    .cell > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .--underThree {
    width: 100%;
  }
  img {
    width: 100%;
    height: auto;
  }
}
</style>